import {BaseAnalyticsEvent} from "./base-analytics-event";

export class DisplayEvent extends BaseAnalyticsEvent {

  constructor(name) {
    super('', 'display', name);
  }

  populate(event: DisplayEvent) { }
}
